import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseBox from '@/components/layout/BaseBox.vue';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import MeasurementForm from '@/forms/MeasurementForm.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_authorized_layout = _resolveComponent("authorized-layout")!

  return (_openBlock(), _createBlock(_component_authorized_layout, { title: "Nové měření" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(BaseFlex, {
          row: "",
          "row-gap": "15px",
          "col-gap": "15px",
          wrap: "nowrap"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFlex, {
              col: "",
              class: "new-measurement-box"
            }, {
              default: _withCtx(() => [
                _createVNode(BaseBox, { title: "Nové měření" }, {
                  default: _withCtx(() => [
                    _createVNode(MeasurementForm)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})